/**
 * Common constants used across tenant handlers
 */

export const DEFAULT_PAGINATION = {
  CURRENT_PAGE: 0,
  TOTAL_PAGES: 1
} as const;

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_LANGUAGE = 'en';

/**
 * Common error messages
 */
export const ERROR_MESSAGES = {
  TENANT_NOT_FOUND: 'Tenant not found',
  INVALID_TENANT_DATA: 'Invalid tenant data provided',
  AUTHENTICATION_FAILED: 'Authentication failed'
} as const;

/**
 * Common cache keys patterns
 */
export const CACHE_KEYS = {
  PAGINATED_TENANT_LIST: 'paginatedTenantList',
  TENANT_BY_ID: 'tenantById'
} as const;
